import { useTranslation } from 'react-i18next'
import { useCustomer } from 'hooks/useSession'
import TextPaper from '@ui/elements/TextPaper'
import { useConfirmCustomer } from '@user/customer/confirmation/useConfirmCustomer'
import { hasTextPaperLines } from '@user/customer/confirmation/getTextPaperStatus'
import useDateFormat from '@ui/hooks/useDateFormat'
import { useMemo } from 'react'

interface Props {
  onPress: () => void
}

export default function CustomerDetails({ onPress }: Props) {
  const { t } = useTranslation(['ui', 'modals'])

  const customer = useCustomer()
  const formatDate = useDateFormat({ dateStyle: 'medium' })
  const { getDetailStatus, needsPersonalInfo, needsAddress, needsVat } =
    useConfirmCustomer()

  const lines = useMemo(() => {
    const { first_name, last_name, ref, birth_date, email, phone, mobile, address } =
      customer || {}

    const { street, street2, zip, city, country_code, vat } = address || {}
    const country_name = country_code
      ? t(`countries:${country_code.toLowerCase()}`)
      : undefined
    const data = [
      [first_name, last_name].filter(Boolean).join(' '),
      ref,
      birth_date ? formatDate(birth_date) : undefined,
      email,
      [mobile, phone].filter(Boolean).join(' '),
      [street, street2].filter(Boolean).join(' '),
      [zip, city].filter(Boolean).join(' '),
      [country_name, country_code].filter(Boolean).join(' '),
    ]
    if (vat) {
      data.push(vat)
    }
    return data
  }, [customer, formatDate, t])

  const status = getDetailStatus({
    hasData: hasTextPaperLines(lines),
    isValid: !needsPersonalInfo && !needsAddress && !needsVat,
  })

  return (
    <TextPaper
      icon="user-circle"
      label={t('modals:personal.title')}
      lines={lines}
      onPress={onPress}
      status={status}
    />
  )
}
